// material
import { Stack, Box } from "@mui/material";

// ----------------------------------------------------------------------

export default function ManifestoSub() {
  return (
    <Stack alignItems="center" spacing={5} sx={{ pt: 5, pb: 10 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-around">
        <Box
          component="img"
          src="/assets/partner1.png"
          alt="PIRATE STUDIOS"
          width="30%"
        />
        <Box
          component="img"
          src="/assets/partner2.png"
          alt="CACHE"
          width="20%"
        />
        <Box
          component="img"
          src="/assets/partner3.png"
          alt="SCAN"
          width="20%"
        />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-around">
        <Box
          component="img"
          src="/assets/partner4.png"
          alt="PIRATE STUDIOS"
          width="30%"
        />
        <Box
          component="img"
          src="/assets/partner5.png"
          alt="CACHE"
          width="30%"
        />
      </Stack>
    </Stack>
  );
}
